import React from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const { cartItems, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();

  const getItemTotal = (item) => {
    const price = Number(item.price) || 0;
    return price * item.quantity;
  };
  
  const total = cartItems.reduce((sum, item) => sum + getItemTotal(item), 0).toFixed(2);
  

  return (
    <div>
      <h2>Your Cart</h2>
      {cartItems.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          {cartItems.map(item => (
  <div
    key={item.id + item.selectedSize}
    style={{
      display: 'flex',
      gap: '1rem',
      borderBottom: '1px solid #ccc',
      padding: '1rem 0',
      alignItems: 'center'
    }}
  >
    <img
  src={`/images/team-merch/${item.image}`}
  alt={item.name}
  style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: '6px' }}
  onError={(e) => { e.target.src = '/images/default-placeholder.png'; }}
/>

    <div style={{ flex: 1 }}>
      <p style={{ marginBottom: 4 }}>
        <strong>{item.name}</strong>
      </p>
      <p style={{ marginBottom: 4 }}>
        Size: {item.selectedSize} | Color: {item.color} | Logo: {item.logo}
      </p>
      <p style={{ marginBottom: 8 }}>
        Price: ${item.price.toFixed(2)} ×{' '}
        <input
          type="number"
          value={item.quantity}
          min="1"
          onChange={(e) =>
            updateQuantity(item.id, item.selectedSize, parseInt(e.target.value))
          }
          style={{ width: 60, marginLeft: 10 }}
        />
      </p>
      <button onClick={() => removeFromCart(item.id, item.selectedSize)}>Remove</button>
    </div>
  </div>
))}
          <h4>Total: ${total}</h4>
          <button onClick={() => navigate('/checkout')}>Proceed to Checkout</button>
        </>
      )}
    </div>
  );
};

export default Cart;
